module.exports = __webpack_public_path__ + "src/assets/img/page4/64744d728286d86514b6e27276de39de.png";